import Button from '@/components/atoms/Button'
import Icon from '@/components/atoms/Icon'
import Input from '@/components/atoms/Input'
import InputGroup from '@/components/atoms/InputGroup'
import { verifySchema } from '@/schemas/auth.schema'
import authService from '@/services/authService'
import companyService from '@/services/companyService'
import inputIsValid from '@/utils/helpers/inputIsValid'
import { yupResolver } from '@hookform/resolvers/yup'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'

type Verify = {
	email: string
}

export default function Form() {
	const { execute: getCompany, data: dataCompany } =
		companyService.getCompanyMutation()

	const {
		execute: signInVerify,
		data: dataVerify,
		isError: isErrorVerify,
		isSuccess: isSuccessVerify,
		isLoading,
	} = authService.signInVerify()

	useEffect(() => {
		if (isSuccessVerify && dataVerify) {
			getCompany({ companyId: dataVerify.empresa_id })
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSuccessVerify])

	const {
		register,
		handleSubmit,
		formState: { errors, touchedFields },
	} = useForm<Verify>({
		mode: 'onSubmit',
		resolver: yupResolver(verifySchema),
	})

	const onSubmit = handleSubmit(signInVerify)

	return (
		<div className='flex flex-col w-full lg:max-w-[370px] xl:max-w-[445px] gap-8'>
			{isSuccessVerify && dataCompany && (
				<div className='flex items-center border border-gray-200/30 py-6 px-5 gap-4 rounded-lg'>
					{dataCompany?.logo && (
						<img
							src={dataCompany?.logo}
							alt='Logo empresa'
							className='w-12 min-w-12 rounded-full bg-white min-h-[48px] object-fill'
						/>
					)}
					{dataCompany?.nome && (
						<p className='text-2xl font-medium leading-[110%] text-black dark:text-white'>
							{dataCompany?.nome}
						</p>
					)}
				</div>
			)}

			<h1 className='font-bold text-[32px] md:text-4xl max-w-[335px] 2lg:max-w-[480px] lg:text-[40px] leading-[110%] text-title dark:text-[#F7F9FB]'>
				Acesse a plataforma Fluency Corporate
			</h1>

			{isSuccessVerify ? (
				<div>
					<div className='bg-[#261947] flex gap-4 text-white rounded-lg items-center justify-center py-6 px-4'>
						<div className='flex items-center justify-center w-12 h-12 min-w-12 min-h-12 bg-[#6b47ed] rounded-full'>
							<Icon
								name='mail'
								width='32'
								height='32'
								className='w-[32px] h-auto text-[#150e1d] dark:text-white'
							/>
						</div>
						<p className='text-base text-white font-medium leading-[130%]'>
							<strong>Confira seu email.</strong> Entre pelo link enviado no
							email para acessar a plataforma.
						</p>
					</div>
				</div>
			) : (
				<form className='w-full md:max-w-[82%]' onSubmit={onSubmit}>
					<div className='flex flex-col gap-3'>
						<div>
							<InputGroup label='Email Corporativo' id='email'>
								<Input
									className='h-10 mb-3'
									isValid={inputIsValid(errors.email, touchedFields.email)}
									{...register('email')}
									type='email'
								/>
							</InputGroup>

							<Button type='submit' isLoading={isLoading}>
								Continuar com Email
							</Button>
						</div>
						{isErrorVerify && (
							<div className='bg-[#3b121e] flex gap-4 text-white rounded-lg items-center justify-center py-6 px-4'>
								<div className='flex items-center justify-center w-12 h-12 min-w-12 min-h-12 bg-[#D31B23] rounded-full'>
									<Icon
										name='warning'
										width='32'
										height='32'
										className='w-[32px] h-auto text-[#150e1d] dark:text-white'
									/>
								</div>
								<p className='text-sm text-white font-medium leading-[130%]'>
									<strong>Não encontramos seu email.</strong> Entre em contato
									com seu gestor ou solicite ajuda do nosso suporte.
								</p>
							</div>
						)}
					</div>
				</form>
			)}
		</div>
	)
}
